import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=2813b52e"
import script from "./BillingAddress.vue?vue&type=script&lang=js"
export * from "./BillingAddress.vue?vue&type=script&lang=js"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=2813b52e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BillingAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2813b52e')) {
      api.createRecord('2813b52e', component.options)
    } else {
      api.reload('2813b52e', component.options)
    }
    module.hot.accept("./BillingAddress.vue?vue&type=template&id=2813b52e", function () {
      api.rerender('2813b52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/address/BillingAddress.vue"
export default component.exports